import { render, staticRenderFns } from "./BuyForModal.vue?vue&type=template&id=3ba9e752&scoped=true&"
import script from "./BuyForModal.vue?vue&type=script&lang=js&"
export * from "./BuyForModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyForModal.vue?vue&type=style&index=0&id=3ba9e752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9e752",
  null
  
)

export default component.exports